import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import "../../common/Common.css";
import UserTable from "./UserTable";
import { useSelector } from "react-redux";
import api from "../../services/api";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      className="branch_tab"
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
    className: "branch_tab",
  };
}

export default function UserComponent() {
  const [value, setValue] = React.useState(0);
  const [userDetails, setUserDetails] = React.useState([]);
  const [roles, setRoles] = React.useState([]);
  const branch = useSelector((state) => state.userDetails.detail?.branches);

  React.useEffect(() => {
    getUsersDetail();
    getRoles();
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const getUsersDetail = async () => {
    let userData = await api.get(`app/management/users/`);
    setUserDetails(userData?.data);
  };
  const getRoles = async () => {
    let roles = await api.get(`app/management/users/roles`);
    setRoles(roles?.data);
  };
  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{ borderBottom: 1, borderColor: "divider", marginBottom: "20px" }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          {branch?.map((b, index) => (
            <Tab
              key={b.id}
              label={b.name}
              {...a11yProps(index)}
              className="branch_name"
            />
          ))}
        </Tabs>
      </Box>
      {branch?.map((b, index) => (
        <CustomTabPanel key={b.id} value={value} index={index}>
          {value === index && ( // only render when active tab
            <UserTable
              userDetails={userDetails.filter((user) =>
                user.branches.some((branchObj) => branchObj.id === b.id)
              )}
              branchId={b.id}
              getUsersDetail={getUsersDetail}
              roles={roles}
            />
          )}
        </CustomTabPanel>
      ))}
    </Box>
  );
}
